/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userskillgroups2Inputs */

const en_entity_userskillgroups2 = /** @type {(inputs: Entity_Userskillgroups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Skill Groups`)
};

const de_entity_userskillgroups2 = /** @type {(inputs: Entity_Userskillgroups2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Skillgruppen`)
};

/**
* | output |
* | --- |
* | "User Skill Groups" |
*
* @param {Entity_Userskillgroups2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userskillgroups2 = /** @type {((inputs?: Entity_Userskillgroups2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userskillgroups2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userskillgroups2(inputs)
	return de_entity_userskillgroups2(inputs)
});
export { entity_userskillgroups2 as "entity_userSkillGroups" }